export const loadScheduledPicker = () => import('@charitystack/shared/controlled-recurring-date-picker');
